(function () {
  if (typeof Swiper === 'undefined') {
    console.warn('[featured-posts] Swiper is not loaded');
    return;
  }

  document.querySelectorAll('.featured-posts__swiper').forEach(function (el) {
    var columnsDesktop = parseInt(el.dataset.columnsDesktop) || 4;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          spaceBetween: 24,
        }
      },
    });
  });
})();
